import { render, staticRenderFns } from "./yipingjia.vue?vue&type=template&id=ff64f572&scoped=true"
import script from "./yipingjia.vue?vue&type=script&lang=js"
export * from "./yipingjia.vue?vue&type=script&lang=js"
import style0 from "./yipingjia.vue?vue&type=style&index=0&id=ff64f572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff64f572",
  null
  
)

export default component.exports